import React, {
  useState,
  useContext,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import { TostMsg } from "../../../App";
import {
  RecoverGroupManage,
  getGroupManage,
  groupDetail,
  UpdateOwner,
  getGroupArchieved,
  deleteGroupChatData,
} from "../Messages/MessageService";
import { Button } from "primereact/button";
import { Paginator } from "primereact/paginator";
import { Dropdown } from "primereact/dropdown";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import { debounce } from "lodash";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
const defaultImage = "/images/placeholder_profile.png";

const MessageGroupSetting = () => {
  const userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [editingRowId, setEditingRowId] = useState(null);
  const [Isloading, setIsloading] = useState(false);
  const [groupManageList, setGroupManageList] = useState([]);
  const [originalGroupManageList, setOriginalGroupManageList] = useState([]);
  const [employeDetails, setEmployeDetails] = useState([]);
  const toster = useContext(TostMsg);
  const [selectNewOwner, setSelectNewOwner] = useState({});
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);

  useEffect(() => {
    GetGroupManage();
    fetchEmployeeIdData();
  }, []);

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  async function GetGroupManage() {
    setIsloading(true);
    try {
      const response = await getGroupManage({ OrgId: userDetails?.OrgId });
      const data = response?.Data?.Data || [];
      setOriginalGroupManageList(data);
      setGroupManageList(data);
    } catch (error) {
      toster.current.error(ERROR_LIST.DefaultError);
    } finally {
      setIsloading(false);
    }
  }

  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        const filteredList = originalGroupManageList.filter((group) =>
          group.GroupName?.toLowerCase().includes(value.toLowerCase())
        );
        setGroupManageList(filteredList);
      }, 800),
    [originalGroupManageList]
  );

  const ChangeOwner = async (GroupId, OrgId) => {
    setEditingRowId(GroupId);
    try {
      const response = await groupDetail({ GroupId: GroupId, OrgId: OrgId });
    } catch (error) {
      console.error("Error in OwnerChange", error);
    }
  };

  const NewOwner = async (el) => {
    setEditingRowId(el?.GroupId);
    const param = {
      GroupId: el?.GroupId,
      OwnerId: selectNewOwner.EmpId ?? el?.OwnerId,
    };
    try {
      await UpdateOwner(param);
      toster.current.success("Group Recovered Successfully!");
      GetGroupManage();
      handleCancel();
    } catch (error) {
      console.error("Error in OwnerChange", error);
    }
  };

  const groupArchive = async (GroupId) => {
    try {
      await getGroupArchieved({ GroupId: GroupId });
      toster.current.success("Group Arhcive Successfully!");
      GetGroupManage();
    } catch (error) {
      console.error("Error in RecoverGroup", error);
    }
  };

  const groupUnArchive = async (GroupId) => {
    try {
      await getGroupArchieved({ GroupId: GroupId });
      toster.current.success("Group UnArhcive Successfully!");
      GetGroupManage();
    } catch (error) {
      console.error("Error in RecoverGroup", error);
    }
  };

  const recoverGroup = async (GroupId) => {
    try {
      await RecoverGroupManage({ Id: GroupId });
      toster.current.success("Group Recovered Successfully!");
      GetGroupManage();
    } catch (error) {
      console.error("Error in RecoverGroup", error);
    }
  };

  const DeleteGroupManage = async (GroupId) => {
    try {
      await deleteGroupChatData({ Id: GroupId });
      toster.current.success("Group Deleted Successfully!");
      GetGroupManage();
    } catch (error) {
      console.error("Error in DeleteGroupManage:", error);
    }
  };

  const employeeOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <LazyImage alt={option.FullName} src={option.ProfileImage} width="32" />
        <span>{option.FullName}</span>
      </div>
    );
  };

  const paginatedList = groupManageList.slice(first, first + rows);
  async function fetchEmployeeIdData() {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    setIsloading(true);
    try {
      let employeesList = await getEmployeeList(params);
      setEmployeDetails(employeesList.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }
  const handleCancel = () => {
    setEditingRowId(null);
  };

  let SearchValue = "";
  const handleInputChange = (event) => {
    const value = event.target.value;
    debouncedSearch(value);
  };

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const handleSearch = useCallback(
    debounce((value) => {
      SearchValue = value;
      let filteredList = groupManageList.filter((group) =>
        group.GroupName?.toLowerCase().includes(SearchValue?.toLowerCase())
      );
      setGroupManageList(filteredList);
    }, 800),
    []
  );

  return (
    <div className="setting-detail-list">
      <div className="detail org-table">
        <div
          className="title-text"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h3>Message Groups ({groupManageList?.length})</h3>
          <div className="input-group search-area2 d-xl-inline-flex mb-3 ">
            <input
              type="text"
              className="form-control search-grpname"
              onChange={handleInputChange}
              placeholder="Search"
            />
          </div>
        </div>

        <div className="col-md-12 column ">
          {Isloading ? (
            <p>Loading...</p>
          ) : groupManageList.length === 0 ? (
            <p>No Groups Found</p>
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-bordered table-hover">
                  <thead>
                    <tr>
                      <th>Logo</th>
                      <th>Name</th>
                      <th>Description</th>
                      <th>Owner</th>
                      <th>Admin </th>
                      <th>Member</th>
                      <th>Status</th>
                      <th style={{ width: "150px" }}>Last Message</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {groupManageList.map((row) => (
                      <tr key={row.GroupId}></tr>
                    ))}
                    {paginatedList.map((row) => (
                      <tr key={row.GroupId}>
                        <td>
                          <img
                            src={row.IconLogo || defaultImage}
                            onError={handleImageError}
                            style={{
                              width: "22px",
                              height: "22px",
                              borderRadius: "50%",
                              objectFit: "cover",
                              marginRight: "8px",
                            }}
                          />
                        </td>
                        <td>{row.GroupName ? row.GroupName : "N/A"}</td>

                        <td
                          title={row.GroupDesc ?? "N/A"}
                          style={{ width: "150px" }}
                        >
                          {row.GroupDesc
                            ? row.GroupDesc.length > 40
                              ? `${row.GroupDesc.slice(0, 40)}...`
                              : row.GroupDesc
                            : "N/A"}
                        </td>

                        {editingRowId === row.GroupId ? (
                          <td>
                            <Dropdown
                              value={selectNewOwner}
                              options={employeDetails}
                              onChange={(e) => setSelectNewOwner(e.value)}
                              optionLabel="FullName"
                              itemTemplate={employeeOptionTemplate}
                              filter
                              className="w-full md:w-14rem"
                              style={{ width: "100%" }}
                            />
                          </td>
                        ) : (
                          <td>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <img
                                src={row.OwnerProfileImage || defaultImage}
                                onError={handleImageError}
                                style={{
                                  width: "22px",
                                  height: "22px",
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                  marginRight: "8px",
                                }}
                              />
                              {row.OwnerName}
                            </div>
                          </td>
                        )}
                        {/*  */}
                        <td>{row.AdminCount}</td>
                        <td>{row.MemberCount}</td>

                        <td
                          style={{
                            color:
                              row.Status === "Active"
                                ? "#6c24ca"
                                : row.Status === "Inactive"
                                ? "#a8a5a5"
                                : row.Status === "Archived"
                                ? "#000000"
                                : "black",
                          }}
                        >
                          {row.Status}
                        </td>
                        <td style={{ width: "150px" }}>
                          {row.LastMessageMedia
                            ? row.LastMessageMedia.length > 40
                              ? `${row.LastMessageMedia.slice(0, 40)}...`
                              : row.LastMessageMedia
                            : "N/A"}
                        </td>
                        <td>
                          {editingRowId === row.GroupId ? (
                            <>
                              <Button
                                icon="pi pi-check"
                                className="p-button-text p-button-success"
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Save"
                                onClick={() => NewOwner(row)}
                              />
                              <Button
                                icon="pi pi-times"
                                className="p-button-text p-button-secondary"
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Cancel"
                                onClick={() => handleCancel()}
                              />
                            </>
                          ) : (
                            <>
                              {row.Status !== "Inactive" &&
                                row.Status !== "Archived" && (
                                  <Button
                                    icon="pi pi-user"
                                    className="p-button-text"
                                    title="Change Owner"
                                    onClick={() => {
                                      ChangeOwner(row.GroupId, row.OrgId);
                                    }}
                                  />
                                )}

                              {row.Status === "Active" && (
                                <Button
                                  className="p-button-text"
                                  style={{
                                    width: "2rem",
                                    justifyContent: "center",
                                  }}
                                >
                                  <img
                                    src="images/setting/archive.png"
                                    onClick={() => groupArchive(row.GroupId)}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Archive"
                                    style={{ width: "13px" }}
                                  />
                                </Button>
                              )}
                              {row.Status === "Archived" && (
                                <Button
                                  className="p-button-text"
                                  style={{
                                    width: "2rem",
                                    justifyContent: "center",
                                  }}
                                >
                                  <img
                                    src="images/setting/unarchive.png"
                                    onClick={() => groupUnArchive(row.GroupId)}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Unarchive"
                                    style={{ width: "15px" }}
                                  />
                                </Button>
                              )}

                              {row.Status !== "Active" && (
                                <Button
                                  icon="pi pi-refresh"
                                  className="p-button-text"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title="Recover"
                                  onClick={() => recoverGroup(row.GroupId)}
                                />
                              )}

                              {row.Status !== "Inactive" && (
                                <Button
                                  icon="pi pi-trash"
                                  className="p-button-text p-button-danger"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title="Delete"
                                  onClick={() => DeleteGroupManage(row.GroupId)}
                                />
                              )}
                            </>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <Paginator
                first={first}
                rows={rows}
                totalRecords={groupManageList.length}
                onPageChange={(e) => {
                  setFirst(e.first);
                  setRows(e.rows);
                }}
                rowsPerPageOptions={[5, 10, 20, 50]}
                className="mt-3"
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MessageGroupSetting;
